































































































































































































































































































































































































































import {
	computed,
	defineComponent,
	PropType,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import { Component } from 'vue';
import { checkIfFullEventOnlineMeetingIsEmpty } from '@front-app/modules/event/util/location';
import { EMPTY_LARGE_LOGO, ImageScale } from '@front-app/services/ImageApi/ImageModel';
import {
	EventImageType,
	EventManagementData,
	EventMeetingVideoType,
	FullEvent,
	ParticipationRole,
	PriceOption,
} from '@front-app/services/EventsApi/EventModel';
import { useConfirmDialog } from '@vueuse/core';
import { EventsLogoStore, getEventsVenueStoreV1 } from '@front-app/store/singletons/Events';
import EditButton from '@front-app/components/buttons/concrete/EditButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { EventRoleRequest } from '@front-app/services/EventsApi/EventsMemberApi';
import { Size, Spacing } from '@front-app/components/constants';
import { readImageFileAsUrlWithMimeType } from '@front-app/util/image';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import {
	isAdminRole,
	canUserManageEvent,
	canLeave,
	shouldSeeLeaveWarning,
	userMustAcceptEventTerms,
	userShouldAutoAcceptTerms,
} from '@front-app/util/permission';
import { participantToAsyncUser } from '@front-app/services/EventsApi/util';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import { Routes } from '@front-app/constants/routes';
import { getDuration } from '@front-app/util/time';
import { getWhiteOrBlackByContrast } from '@front-app/util/color';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { useEventAdminStore } from '@front-app/modules/event/store/EventAdmin';
import { UseEventStore, useEventStore } from '@front-app/modules/event/store/Event';
import { BannerLocation } from '@front-app/services/ActionApi/UserActionRequestModel';
import { syncedRef } from '@front-app/util/reactivity';
import { useEventBanner } from '@front-app/modules/event/hooks/useEventBanner';
import { useEventMembershipRole } from '@front-app/hooks/useMembershipRole';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import EventImageCropper from '@front-app/components/event/EventImageCropper.vue';
import LargeRoundIcon from '@front-app/components/icons/LargeRoundIcon.vue';
import FileInput from '@front-app/components/inputs/FileInput.vue';
import TrAddress from '@front-app/components/TrAddress.vue';
import EditEventTitleModal from '@front-app/modules/event/components/form/EditEventTitleModal.vue';
import EditEventDatesModal from '@front-app/modules/event/components/form/EditEventDatesModal.vue';
import EditEventLocationModal from '@front-app/modules/event/components/form/EditEventLocationModal.vue';
import EditEventSpeakersModal from '@front-app/modules/event/components/form/EditEventSpeakersModal.vue';
import EditEventPriceModal from '@front-app/modules/event/components/form/EditEventPriceModal.vue';
import EditEventTypesModal from '@front-app/modules/event/components/form/EditEventTypesModal.vue';
import EditEventTopicsModal from '@front-app/modules/event/components/form/EditEventTopicsModal.vue';
import EditEventDescriptionModal from '@front-app/modules/event/components/form/EditEventDescriptionModal.vue';
import EventDates from '@front-app/modules/events/components/EventDates.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import TermsCard from '@front-app/components/cards/TermsCard.vue';
import EventTypeBadge from '@front-app/components/buttons/concrete/EventTypeBadge.vue';
import EventCategoryBadge from '@front-app/components/buttons/concrete/EventCategoryBadge.vue';
import MemberList from '@front-app/components/group/MemberList.vue';
import AddToCalendar from '@front-app/components/buttons/AddToCalendar.vue';
import WarningCard from '@front-app/components/cards/state/WarningCard.vue';
import EventPageTitle from './EventPageTitle.vue';
import DeclineEventInvitation from './DeclineEventInvitation.vue';
import EventGatingModal from './EventGatingModal.vue';

interface UseEventMemberStateChange {
	isChangingState: Ref<boolean>;
	request(targetRole: EventRoleRequest): Promise<void>;
}

const useEventMemberStateChange = (event: Ref<FullEvent | undefined>, eventStore: ReturnType<UseEventStore>): UseEventMemberStateChange => {
	const { track, isLoading } = useAsyncStatus();
	return {
		isChangingState: isLoading,
		async request(targetRole: EventRoleRequest): Promise<void> {
			const eventState = event.value;
			if (!eventState) {
				return;
			}
			// eslint-disable-next-line no-param-reassign
			await track(eventStore.updateMemberRole(eventState.id, targetRole));
		},
	};
};

enum EventInfoType {
	NONE = 'NONE',
	TITLE = 'TITLE',
	DATES = 'DATES',
	LOCATION = 'LOCATION',
	SPEAKERS = 'SPEAKERS',
	PRICE = 'PRICE',
	TYPE = 'TYPE',
	TOPICS = 'TOPICS',
	DESCRIPTION = 'DESCRIPTION',
}

const EDIT_EVENT_PANEL_BY_TYPE: Record<Exclude<EventInfoType, EventInfoType.NONE>, Component> = {
	[EventInfoType.TITLE]: EditEventTitleModal,
	[EventInfoType.DATES]: EditEventDatesModal,
	[EventInfoType.LOCATION]: EditEventLocationModal,
	[EventInfoType.SPEAKERS]: EditEventSpeakersModal,
	[EventInfoType.PRICE]: EditEventPriceModal,
	[EventInfoType.TYPE]: EditEventTypesModal,
	[EventInfoType.TOPICS]: EditEventTopicsModal,
	[EventInfoType.DESCRIPTION]: EditEventDescriptionModal,
};

export default defineComponent({
	components: {
		CtaButton,
		ColumnContainer,
		EditButton,
		EventImageCropper,
		FileInput,
		PaddedContent,
		SimpleCard,
		SlidingPanel,
		LargeRoundIcon,
		TermsCard,
		TrAddress,
		EventTypeBadge,
		EventCategoryBadge,
		MemberList,
		AddToCalendar,
		EventDates,
		EventPageTitle,
		DeclineEventInvitation,
		EventGatingModal,
		WarningCard,
	},
	props: {
		event: {
			type: Object as PropType<FullEvent>,
			required: true,
		},
		groupId: {
			type: String,
			default: '',
		},
		isAdministrationPage: Boolean,
	},
	setup(props, ctx) {
		// Permissions
		const isEventAdmin = computed(() => isAdminRole(props.event.role));
		const canManageEvent = computed(() => canUserManageEvent(CurrentUserStore.isCsr.value, props.event));
		const canEditEvent = computed(() => props.isAdministrationPage && canManageEvent.value);

		// Edit
		const editEventPanel = useConfirmDialog();
		const isEditEventPanelOpen = editEventPanel.isRevealed;
		const selectedEventInfoType = ref(EventInfoType.NONE);
		const openEditEventPanel = (eventInfoType: EventInfoType) => {
			selectedEventInfoType.value = eventInfoType;
			editEventPanel.reveal();
		};
		const closeEditEventPanel = () => {
			editEventPanel.cancel();
			selectedEventInfoType.value = EventInfoType.NONE;
		};
		const eventAdminStore = useEventAdminStore();
		const adminEvent: Ref<undefined | EventManagementData> = computed(() => (canEditEvent.value ? eventAdminStore.getById(props.event.id) : undefined));
		watch(canEditEvent, async (curr) => {
			if (curr) {
				await eventAdminStore.fetch(props.event.id);
			}
		}, { immediate: true });
		// END Edit

		// Join, Terms, Decline invite
		const {
			request: requestStateChange,
			isChangingState: isJoining,
		} = useEventMemberStateChange(computed(() => props.event), useEventStore());
		const joinEvent = () => requestStateChange(EventRoleRequest.ACCEPT);
		const leaveEvent = () => requestStateChange(EventRoleRequest.IGNORE);
		const acceptTerms = () => requestStateChange(EventRoleRequest.TERMS);
		const canDeclineInvitation = computed(() => useEventMembershipRole(props.event.role).isInvitee);
		// END Join & Terms

		// Venue and images
		const venueImageStore = getEventsVenueStoreV1();
		watch(() => props.event.id, (curr) => {
			EventsLogoStore.fetch(curr, ImageScale.LARGE_4X);
		}, { immediate: true });
		watch(() => props.event.venueImageSrc, (curr) => {
			venueImageStore.fetch(curr);
		}, { immediate: true });
		const logo = computed(() => EventsLogoStore.get(props.event.id, ImageScale.LARGE_4X));
		const venueImage = computed(() => venueImageStore.get(props.event.venueImageSrc));
		const hasVenueImage = computed(() => {
			const { src } = venueImage.value;
			return src && src !== EMPTY_LARGE_LOGO;
		});

		const isImageCropperVisible = ref(false);
		const selectedImageType = ref(EventImageType.LOGO);
		const eventImageUrl = ref('');
		const eventImageMimeType = ref('');
		const cropAndUpdateEventImage = async (type: EventImageType, files: File[]) => {
			if (files.length < 1) {
				return;
			}
			const eventImage = files[0];

			URL.revokeObjectURL(eventImageUrl.value);
			const {
				mimeType,
				imageUrl,
			} = await readImageFileAsUrlWithMimeType(eventImage);
			eventImageUrl.value = imageUrl;
			eventImageMimeType.value = mimeType;

			selectedImageType.value = type;
			isImageCropperVisible.value = true;
		};
		// END Venue and images

		// Meeting button
		const onlineMeetingButton = syncedRef(() => checkIfFullEventOnlineMeetingIsEmpty(props.event.onlineMeeting)).ref;
		const hasMeetingButton = computed(() => onlineMeetingButton.value.videoType !== EventMeetingVideoType.NONE);
		const meetingButtonTextColor = computed(() => getWhiteOrBlackByContrast(onlineMeetingButton.value.videoButtonColor));
		// END Meeting button

		// Speakers
		const speakers: Ref<PartialUser[]> = computed(() => props
			.event
			.participants
			.filter(({ participationRole }) => participationRole === ParticipationRole.SPEAKER)
			.map(participantToAsyncUser));
		// END Speakers

		// Meta
		const registerOrUnregister = async () => {
			const confirmationText = isEventAdmin.value
				? ctx.root.$t('event.leave.confirmation-admin')
				: ctx.root.$t('event.leave.confirmation');

			if (canLeave(props.event)) {
				const shouldLeave = shouldSeeLeaveWarning(props.event)
					// eslint-disable-next-line no-alert
					&& window.confirm(confirmationText as string);
				if (shouldLeave) {
					leaveEvent();
				}
			// Admins and CSRs should auto-accept terms
			} else if (userShouldAutoAcceptTerms(props.event, CurrentUserStore.isCsr.value)) {
				acceptTerms();
			} else {
				joinEvent();
			}
		};
		// If the admin has required all members to re-accept terms, then the admin should also auto-re-accept
		watch(() => userShouldAutoAcceptTerms(props.event, CurrentUserStore.isCsr.value), (curr: boolean) => {
			if (curr) {
				acceptTerms();
			}
		}, { immediate: true });
		// END Meta

		// Maps
		const hasMap = computed(() => {
			const { address } = props.event;
			return !address.empty
				&& Boolean(address?.longitude)
				&& Boolean(address?.latitude);
		});
		const mapsSrc = computed(() => `https://maps.google.com/maps?output=embed&key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&q=${props.event.address?.latitude},${props.event.address?.longitude}&zoom=15`);
		// END Maps

		// Terms & Join
		const termsAcceptanceRequiredForUser = computed(() => (!canEditEvent.value && userMustAcceptEventTerms(props.event, CurrentUserStore.isCsr.value)));
		const handleTermsClose = async () => {
			leaveEvent();
		};
		// END Terms & Join

		// Banner
		const eventBannerData = computed(() => ({
			eventId: props.event.id,
			location: termsAcceptanceRequiredForUser.value ? BannerLocation.EVENT_PAGE_WELCOME : BannerLocation.EVENT_PAGE_MAIN,
			disableTracking: props.isAdministrationPage,
			groupId: props.groupId,
		}));
		const {
			banner,
			bannerWrapper,
		} = useEventBanner(eventBannerData);
		// END Banner

		// Time
		const eventDuration = computed(() => getDuration(ctx, new Date(props.event.startDate), new Date(props.event.endDate)));
		const calendarDescription = computed(() => `${ctx.root.$t('event-page.calendar-invitation')} ${process.env.VUE_APP_TRAPP_URL}/fvgbd.shtml?gd=${props.event.id}

		${props.event.description}`);
		// END Time

		// Streams
		const getHexColor = (color: string): string => {
			if (color.indexOf('#') === 0) {
				return color;
			}
			return `#${color}`;
		};
		// END Streams

		return {
			canManageEvent,
			// Edit
			adminEvent,
			canEditEvent,
			openEditEventPanel,
			closeEditEventPanel,
			isEditEventPanelOpen,
			selectedEventInfoType,
			EventInfoType,
			EDIT_EVENT_PANEL_BY_TYPE,
			// Terms, join, leave, decline invite
			canDeclineInvitation,
			isJoining,
			acceptTerms,
			// Header
			banner,
			bannerWrapper,
			speakers,
			// Meta
			canLeave,
			registerOrUnregister,
			// Images
			logo,
			// Maps
			hasMap,
			mapsSrc,
			hasVenueImage,
			venueImage,
			// Updating images
			EventImageType,
			selectedImageType,
			eventImageUrl,
			eventImageMimeType,
			isImageCropperVisible,
			cropAndUpdateEventImage,
			// Meeting button
			hasMeetingButton,
			onlineMeetingButton,
			meetingButtonTextColor,
			// Terms & Join
			handleTermsClose,
			termsAcceptanceRequiredForUser,
			// Time
			eventDuration,
			calendarDescription,
			// Util
			getHexColor,
			ButtonPalettes,
			PriceOption,
			Routes: {
				GROUP_EVENTS: Routes.GROUP_EVENTS,
			},
			Size,
			Spacing,
		};
	},
});
